import { Badge, Button, Table } from "react-bootstrap";
import { FaLink, FaEdit, FaTrash } from "react-icons/fa";
import classes from "./ExternalSystemsTable.module.css";

const formatarData = (dataStr, showTime = true) => {
    if (!dataStr) return '';

    const partes = dataStr.split(' ');
    if (partes.length !== 2) return dataStr;

    const [ano, mes, dia] = partes[0].split('-');
    const hora = showTime ? ' ' + partes[1] : '';

    return `${dia}/${mes}/${ano}${hora}`;
}

export default function ExternalSystemsTable({ externalSystems, externalSystemTypes, statusTypes, onEdit, onDelete }) {
    console.warn("----------------------------------------------");
    console.warn(externalSystems)
    const badgeColor = (status) => {
        if (status === 3) return "danger";
        if (status === 2) return "secondary";
        if (status === 1) return "success";
        if (status === 0) return "danger";
        return "secondary";
    };

    return (
        <div className="table-responsive">
            <Table bordered className={classes.customTable}>
                <thead className="table-dark">
                    <tr>
                        <th>ID</th>
                        <th>Título</th>
                        <th className="text-center">Link</th>
                        <th className="text-center">Descrição</th>
                        <th>Status</th>
                        <th>Criado em</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>
                    {externalSystems && externalSystems.map((sys, index) => {

                        const rowStyle = index % 2 === 0
                            ? classes.rowEven
                            : classes.rowOdd;

                        return (
                            <tr key={sys.id} className={rowStyle}>

                                <td>{sys.id}</td>

                                <td>{sys.title}</td>


                                <td>
                                    <a href='{sys.link}'><FaLink /></a><br />
                                    <small>{sys.link}</small>
                                </td>

                                <td>{sys.description}</td>

                                <td>
                                    <Badge bg={badgeColor(sys.status)}>
                                        {sys.status === 1 ? 'HABILITADO' : 'DESABILITADO'}
                                    </Badge>
                                </td>

                                <td className="text-nowrap">
                                    {formatarData(sys.created)}
                                </td>

                                <td>
                                    <div className="d-flex justify-content-center">

                                        <Button
                                            size="sm"
                                            variant="outline-primary"
                                            className="me-1"
                                            title="Editar"
                                            onClick={() => onEdit(sys)}
                                        >
                                            <FaEdit />
                                        </Button>

                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            title="Excluir"
                                            onClick={() => onDelete(sys)}
                                        >
                                            <FaTrash />
                                        </Button>

                                    </div>
                                </td>

                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}
